var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBookSpaceInovateIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 33,
    viewBox: "0 0 35 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 16.3359H35",
    stroke: "white",
    strokeWidth: 2.33333,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.50195 32.6693V16.3359",
    stroke: "white",
    strokeWidth: 2.33333,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5 32.6693V16.3359",
    stroke: "white",
    strokeWidth: 2.33333,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.50195 16.3359H31.502V25.6693C31.502 27.6024 29.9351 29.1693 28.002 29.1693H7.00195C5.06879 29.1693 3.50195 27.6024 3.50195 25.6693V16.3359Z",
    stroke: "white",
    strokeWidth: 2.33333,
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8359 15.1719V8.17188",
    stroke: "white",
    strokeWidth: 2.33333,
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5013 1.16797H29.168L31.5013 9.33464H22.168L24.5013 1.16797Z",
    stroke: "white",
    strokeWidth: 2.33333,
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M7 10.5039H12.8333V16.3372H7V10.5039Z",
    stroke: "white",
    strokeWidth: 2.33333,
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M9.09067 10.5353L7 5.83594",
    stroke: "white",
    strokeWidth: 2.33333,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookSpaceInovateIcon);
export default __webpack_public_path__ + "static/media/book-space-inovate-icon.793982e9e63a3224dcd7b26b65dc0f77.svg";
export { ForwardRef as ReactComponent };